import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import { handleloading } from "../../Store/Redux/Reducers/Dashboardreducers";
import {
  CatchMessage,
  CheckUserType,
  JSONtoformdata,
  tokenisValid,
} from "../../Shared/Methods";
import { HandleSessionModal } from "../../Store/Redux/Reducers/Authreducers";
import {
  DeleteDeviceDate,
  DeviceListData,
  DropdownService,
} from "../../Services/ApiServices";
import classes from "./HomeScreen.module.css";
import searchicon from "../../Assests/Images/search.png";
import crossimg from "../../Assests/Images/wrong.png";
import FilterDevice from "../../Components/Filters/FilterDevice";
import { getDisplayCount } from "../../Components/Tables/DisplayTableDataCount";
import DeviceCreateModal from "../../Modals/DeviceCreateModal";
import Loader from "../../SharedComponents/Loader/Loader";
import CommonButton from "../../Components/Buttons/CommonButton";
import Newcommontable from "../../Components/Tables/NewCommonTable";
import Commonpagination from "../../Components/Tables/CommonPagination";
import DeviceTable from "../../Components/Tables/DeviceTable";
import DeleteConfirmation from "../../Modals/DeleteConfirmation";
import UpdateRealyNameModal from "../../Modals/Device/UpdateRealyNameModal";

interface DataType {
  key: string;
  name: string;
  age: number;
  address: string;
  tags: string[];
}

function Device({ value }: any) {
  const dispatch = useDispatch();
  const { loading } = useSelector((state: any) => state.Dashboard);
  const { LoginData } = useSelector((state: any) => state.Auth);
  const [deviceList, setDeviceList] = useState<any>([]);
  const [Values, setValues] = useState({
    deviceName: "",
    device_code: "",
  });
  const [pageSize, setpageSize] = useState(10);
  const [pageind, setPageInd] = useState(0);
  const [showfilter, setShowFilter] = useState(false);
  const [showModal, setShowModal] = useState<any>({
    isView: false,
    item: "",
    create: "",
  });
  const [dataViewModal, SetdataViewModal] = useState<any>({
    isView: false,
    item: "",
  });
  const [showConfirmModal, setShowConfirmModal] = useState<any>({
    isView: false,
    item: "",
  });
  const { items, page, total_count, size } = deviceList;
  const [DropDowns, setDropDowns] = useState({
    Baudrate: [],
    Parity: [],
    Databits: [],
  });

  useEffect(() => {
    if (LoginData !== null) {
      handleGetDeviceList(1, 10);
    }
  }, [LoginData]);

  const ResetForm = () => {
    handleGetDeviceList(1, size, value, true);
    setValues({
      deviceName: "",
      device_code: "",
    });
  };

  const DeleteDevice = (id: number) => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      deviceId: id,
    };
    DeleteDeviceDate(JSONtoformdata(finalObj))
      .then(async (res) => {
        if (res.data.status === 1) {
          toast.success(res.data.msg);
          setPageInd(
            deviceList?.items?.length === 1 && deviceList?.page !== 1
              ? pageind - 1
              : pageind
          );
          handleGetDeviceList(
            deviceList?.items?.length === 1 && deviceList?.page !== 1
              ? deviceList?.page - 1
              : deviceList?.page,
            pageSize,
            Values
          );
        } else if (res.data.status === -1) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res.data.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res.data.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => dispatch(handleloading(false)));
  };

  const handleGetDeviceList = (
    page = 1,
    size = 10,
    filterData?: any,
    isreset = false
  ) => {
    dispatch(handleloading(true));
    let finalObj = {
      token: LoginData?.token,
    };

    const WithValues = !isreset
      ? Object.assign(finalObj, filterData ? filterData : Values)
      : finalObj;

    DeviceListData(JSONtoformdata(WithValues), page, size)
      .then(async (res) => {
        if (res.data.status === 1) {
          setDeviceList(res.data.data);
          if (filterData && !isreset) {
            setValues(filterData);
            setShowConfirmModal({ isView: false, item: "" });
          }
          setPageInd(page > 1 ? page - 1 : 0);
        } else if (res.data.status === -1) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res.data.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res.data.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  const getDataBitsDropDown = () => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
    };
    DropdownService(JSONtoformdata(finalObj), "databitsDropdown")
      .then(async (res) => {
        if (res?.data?.status === 1) {
          setDropDowns((pre) => {
            return {
              ...pre,
              Databits: res.data.data,
            };
          });
        } else if (res?.data?.status === 0) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res?.data?.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  const getParityDropDown = () => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
    };
    DropdownService(JSONtoformdata(finalObj), "parityDropdown")
      .then(async (res) => {
        if (res?.data?.status === 1) {
          setDropDowns((pre) => {
            return {
              ...pre,
              Parity: res.data.data,
            };
          });
        } else if (res?.data?.status === 0) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res?.data?.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  const getBaudrateDropDown = () => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
    };
    DropdownService(JSONtoformdata(finalObj), "baudrateDropdown")
      .then(async (res) => {
        if (res?.data?.status === 1) {
          setDropDowns((pre) => {
            return {
              ...pre,
              Baudrate: res.data.data,
            };
          });
        } else if (res?.data?.status === 0) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res?.data?.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  const handleCancel = () => {
    setShowConfirmModal({ isView: false, item: "" });
    setShowModal({
      isView: false,
      item: "",
      create: "",
    });
    SetdataViewModal({ isView: false, item: "" });
  };

  const Changesize = (current: number, size: number) => {
    // setPageInd(0); //change into 0 from 1
    setpageSize(size);
    handleGetDeviceList(1, size);
  };

  return (
    <>
      <Loader isLoader={loading} />

      {showModal?.isView ? (
        <DeviceCreateModal
          handleSuccess={(type: string) => {
            handleGetDeviceList(type === "create" ? 1 : page, size);
            // setPageInd(0);
            // setpageSize(10);
          }}
          Action={showModal?.create}
          onCancel={handleCancel}
          item={showModal?.item}
          closable={!showModal?.isView}
          open={showModal?.isView}
          DropDowns={DropDowns}
          DropdownMethods={{
            getBaudrateDropDown,
            getParityDropDown,
            getDataBitsDropDown,
          }}
        />
      ) : null}

      {showConfirmModal?.isView ? (
        <DeleteConfirmation
          handleSuccess={() => {
            handleGetDeviceList();
            DeleteDevice(showConfirmModal?.item?.deviceId);
          }}
          itemName={showConfirmModal?.item?.deviceName}
          Delete={true}
          open={showConfirmModal?.isView}
          closable={!showConfirmModal?.isView}
          onCancel={handleCancel}
        />
      ) : null}

      {/* {dataViewModal?.isView ? (
        <Viewdatamodal
          item={dataViewModal?.item}
          onCancel={handleCancel}
          open={dataViewModal?.isView}
          closable={!dataViewModal?.isView}
        />
      ) : null} */}

      <div className="header_container justify-content-end">
        {/* <h3>Device</h3> */}
        <div className="header_right_container">
          <div className="search_bg">
            {!showfilter ? (
              <img
                src={searchicon}
                className="search_icon"
                onClick={() => setShowFilter(true)}
                alt="searchicon"
              />
            ) : (
              <img
                src={crossimg}
                className="search_icon"
                onClick={() => setShowFilter(false)}
                alt="crossimg"
              />
            )}
          </div>
          {CheckUserType() ? (
            <CommonButton
              name="Create Device"
              onClick={() => {
                setShowModal({ ...showModal, isView: true, create: "Create" });
              }}
              type="button"
              classname="create_btn"
              style={{ padding: "6px 8px", maxWidth: "126px" }}
            />
          ) : null}
        </div>
      </div>
      <div className={classes.table_container_background}>
        <FilterDevice
          showfilter={showfilter}
          pageSize={pageSize}
          pageind={pageind}
          GetList={handleGetDeviceList}
          setpageSize={setpageSize}
          setPageInd={setPageInd}
          ResetForm={ResetForm}
          deviceList={deviceList}
        />
        <div>
          {getDisplayCount(deviceList?.page, pageSize, deviceList?.total_count)}
        </div>
        {/* <DeviceTable
          deviceList={deviceList}
          pageSize={pageSize}
          pageind={pageind}
          GetList={handleGetDeviceList}
          setpageSize={setpageSize}
          setPageInd={setPageInd}
          columns={columns}
        /> */}
        <Newcommontable
          Children={
            <DeviceTable
              Data={deviceList}
              pageSize={pageSize}
              pageind={pageind}
              GetList={handleGetDeviceList}
              setpageSize={setpageSize}
              setPageInd={setPageInd}
              OBJHead={[
                "S.No",
                "Device Name",
                "Device Code",
                // "Total Consumption",
                "Last Communicated Time",
                // "Baudrate",
                // "Databits",
                // "Parity",
                // "Relay One",
                // "Relay Two",
                // "Relay One",
                // "Relay Two",
                "Mac Address",
                "IMEI Number",
                "Created At",
                "Action",
              ]}
              OBJKeys={[
                "deviceName",
                "device_code",
                // "wh_received",
                "last_communicated_time",
                // "baudrate",
                // "databits",
                // "parity_name",
                // "relay1",
                // "relay2",
                // "relay1_name",
                // "relay2_name",
                "macAddress",
                "imeiNumber",
                "created_at",
              ]}
              SetdataViewModal={SetdataViewModal}
              setShowModal={setShowModal}
              setShowConfirmModal={setShowConfirmModal}
            />
          }
        />

        <div>
          <Commonpagination
            onShowSizeChange={Changesize} ///call when page size click
            total={total_count}
            current={page}
            onChange={(e, size) => {
              ///call when page number click
              if (size === pageSize) {
                handleGetDeviceList(e, size);
              }
            }}
            pageSize={size}
          />
        </div>
      </div>
    </>
  );
}

export default Device;
